import { ModalContext } from 'app/app';
import axios from 'axios';
import { IconedButton } from 'components/IconedButton';
import { Pagination } from 'components/Pagination';
import {
  Animate,
  Grid,
  Loader,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './styles.module.scss';

export function PolicyNotifications(props) {
  const { id } = useParams();
  const [payload, setPayload] = useState();
  const [companyData, setCompanyData] = useState({});
  const [agencyData, setAgencyData] = useState({});
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');

  const format = new DateUtils();
  const { setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);

  const options = [
    {
      value: 'missed_payment',
      label: 'Missed Payment',
    },
    {
      value: 'down_payment',
      label: 'Down Payment',
    },
    {
      value: 'underwriting',
      label: 'Underwriting',
    },
    {
      value: 'eld_camera',
      label: 'ELD/camera',
    },
    {
      value: 'mvr_loss_runs',
      label: 'MVR/Loss Runs',
    },
    {
      value: 'other',
      label: 'Other',
    },
  ];

  async function runAPI(page, search, firstTime) {
    if (firstTime) {
      setLoading(true);

      const policyData = await axios.get(`/api/quote/${id}`);
      const promises = await Promise.all([
        axios.get(
          `/api/notification?search=${search}&page=${page}&policy_id=${id}`
        ),
        axios.get(`/api/account/${policyData.data.data.account_id}`),
        axios.get(`/api/company/${policyData.data.data.company_id}`),
      ]);

      var temporary = [];
      const timezone = await format.getTimezone();
      promises[0].data.data.data.map((value, index) => {
        temporary.push({
          id: value.id,
          alert: options.find((op) => op.value === value.alert).label,
          notes: value.notes,
          'Created At': format.timestamp(value.createdAt, timezone),
        });
      });

      setPayload(promises[0].data.data);
      setAgencyData(promises[1].data.data);
      setCompanyData(promises[2].data.data);
      setNotifications(temporary);
      setLoading(false);
    } else {
      setTableLoading(true);

      const promises = await Promise.all([
        axios.get(
          `/api/notification?search=${search}&page=${page}&policy_id=${id}`
        ),
      ]);

      var temporary = [];
      const timezone = await format.getTimezone();
      promises[0].data.data.data.map((value, index) => {
        temporary.push({
          id: value.id,
          alert: options.find((op) => op.value === value.alert).label,
          notes: value.notes,
          'Created At': format.timestamp(value.createdAt, timezone),
        });
      });

      setPayload(promises[0].data.data);
      setNotifications(temporary);
      setTableLoading(false);
    }
  }

  useEffect(() => {
    runAPI(page, '', true);
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Animate type="pop">
            <div
              className={styles.agencyOverview}
              style={{ marginBottom: 20 }}
            >
              <div className={styles.left}>
                <div>
                  <div className={styles.rowInfo}>
                    <div className={styles.info}>
                      <span>Agency:</span>
                      <span>
                        {agencyData && agencyData.name
                          ? agencyData.name
                          : ''}
                      </span>
                    </div>
                    <div className={styles.info}>
                      <span>Owner:</span>
                      <span>
                        {agencyData && agencyData.owner_name
                          ? agencyData.owner_name
                          : ''}
                      </span>
                    </div>
                  </div>
                  <div className={styles.rowInfo}>
                    <div className={styles.info}>
                      <span>Company Name:</span>
                      <span>
                        {companyData && companyData.name
                          ? companyData.name
                          : ''}
                      </span>
                    </div>
                  </div>
                  <div className={styles.rowInfo}>
                    <div className={styles.info}>
                      <span>Company Email:</span>
                      <span>
                        {companyData && companyData.email
                          ? companyData.email
                          : ''}
                      </span>
                    </div>
                  </div>
                  <div className={styles.rowInfo}>
                    <div className={styles.info}>
                      <span>Company Phone:</span>
                      <span>
                        {companyData && companyData.phone
                          ? companyData.phone
                          : ''}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.right}></div>
            </div>
            <div
              style={{
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex' }}>
                <div
                  style={{
                    width: '150px',
                    backgroundColor: 'black',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 10,
                    fontSize: 16,
                    fontWeight: 600,
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                    cursor: 'default',
                  }}
                >
                  Notifications
                </div>
              </div>
              <IconedButton
                size="180px"
                color="#d32425"
                textColor="white"
                icon="plus-circle"
                text="Add Notification"
                action={() => {
                  setModal({
                    name: 'notification_modal',
                    mode: 'create',
                    action: () => runAPI(page, ''),
                    data: {
                      account_id: agencyData.id,
                      company_id: companyData.id,
                    },
                  });
                }}
              />
            </div>
            <Grid cols="1">
              <div className={styles.wrapper}>
                <div style={{ margin: 20 }}>
                  <div style={{ marginBottom: 30 }}>
                    <Search
                      callback={(query) => {
                        setSearchQueryString(query);
                      }}
                    />
                  </div>
                  <Table
                    loading={tableLoading}
                    data={notifications}
                    badge={{
                      col: 'status',
                      condition: [
                        { value: 'Active', color: 'green' },
                        { value: 'Inactive', color: 'red' },
                      ],
                    }}
                    hide={['link', 'id']}
                    actions={{
                      custom: [
                        {
                          icon: 'edit',
                          action: (row) => {
                            setModal({
                              name: 'notification_modal',
                              mode: 'edit',
                              action: () => runAPI(page, ''),
                              data: {
                                id: row.id,
                                alert: row.alert,
                                notes: row.notes,
                              },
                            });
                          },
                          color: '#637381',
                        },
                        {
                          icon: 'trash',
                          action: (row) => {
                            setModal({
                              name: 'confirmation',
                              data: {
                                description: `Do you really want to delete this notification?`,
                              },
                              action: async () => {
                                setModal({});

                                await axios
                                  .delete(
                                    `/api/notification/${row.id}`
                                  )
                                  .then((r) => {
                                    setTableLoading(false);
                                    setModal('');

                                    context.notification.show(
                                      'Notification deleted!',
                                      'success',
                                      true,
                                      'toast',
                                      'check-circle'
                                    );

                                    runAPI(1, '');
                                  })
                                  .catch((error) => {
                                    console.log(error);

                                    setTableLoading(false);
                                    setModal('');
                                    runAPI(1, '');
                                  });

                                setModal('');
                              },
                            });
                          },
                          color: '#637381',
                        },
                      ],
                    }}
                  />
                  {!loading && payload && (
                    <Pagination
                      pagesCount={payload.pages_count}
                      active={payload.page}
                      onChange={async (newPage) => {
                        setPage(newPage);
                        runAPI(newPage, searchQueryString);
                      }}
                    />
                  )}
                </div>
              </div>
            </Grid>
          </Animate>
        </>
      )}
    </>
  );
}
